import * as React from 'react';

interface IProps {
    className?: string;
    onClick?(): void;
}

export const BaseArrowDown: React.FC<IProps> = ({ className, onClick }) => (
    <svg
        className={className}
        version="1.1"
        viewBox="0 0 28 15"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        onClick={onClick}
    >
        <g
            fill="none"
            fillRule="evenodd"
            id="designs"
            opacity="0.6"
            stroke="none"
            strokeLinecap="square"
            strokeWidth="1"
        >
            <g
                id="07-questions-02-copy-7"
                stroke="#000000"
                strokeWidth="2"
                transform="translate(-173.000000, -690.000000)"
            >
                <g id="Group" transform="translate(174.500000, 691.000000)">
                    <path d="M0.5,0.5 L12.5,12.5" id="Line" />
                    <path
                        d="M12.5429688,0.5 L24.5429687,12.5"
                        id="Line-Copy"
                        transform="translate(18.542969, 6.500000) rotate(-270.000000) translate(-18.542969, -6.500000) "
                    />
                </g>
            </g>
        </g>
    </svg>
);
